import { useState } from "react"
import { SiteFooter } from "../../components/SiteFooter.js"
import { ActiveFilterTags } from "./ActiveFilterTags.js"
import { BenefitCard } from "./BenefitCard.js"
import styles from "./BenefitListPage.module.css"
import { FilterDrawer } from "./FilterDrawer.js"
import { FilterPanel } from "./FilterPanel.js"
import { MobileFilterBar } from "./MobileFilterBar.js"
import { Pagination } from "./Pagination.js"
import { SearchBar } from "./SearchBar.js"
import { SortBar } from "./SortBar.js"
import { useBenefits } from "./useBenefits.js"

export function BenefitListPage() {
  const {
    items,
    total,
    totalAll,
    page,
    totalPages,
    filters,
    filterCounts,
    updateFilters,
    isLoading,
    error,
  } = useBenefits()
  const [drawerOpen, setDrawerOpen] = useState(false)

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <div className={styles.headerInner}>
          <h1 className={styles.logo}>株主優待ナビ</h1>
          <SearchBar value={filters.query} onChange={(q) => updateFilters({ query: q })} />
        </div>
      </header>

      <main className={styles.main}>
        <aside className={styles.sidebar}>
          <FilterPanel filters={filters} counts={filterCounts} onChange={updateFilters} />
        </aside>

        <section className={styles.content}>
          <MobileFilterBar filters={filters} onOpenDrawer={() => setDrawerOpen(true)} />

          <SortBar
            total={total}
            totalAll={totalAll}
            sort={filters.sort}
            order={filters.order}
            onChange={(sort, order) => updateFilters({ sort, order })}
          />

          <ActiveFilterTags filters={filters} onChange={updateFilters} />

          {isLoading && <div className={styles.loading}>読み込み中...</div>}
          {error && (
            <div className={styles.error}>
              データの取得に失敗しました。しばらくしてから再度お試しください。
            </div>
          )}

          {!isLoading && !error && items.length === 0 && (
            <div className={styles.empty}>条件に一致する優待情報が見つかりませんでした。</div>
          )}

          <div className={styles.list}>
            {items.map((benefit) => (
              <BenefitCard key={benefit.id} benefit={benefit} query={filters.query} />
            ))}
          </div>

          {totalPages > 1 && <Pagination page={page} totalPages={totalPages} />}
        </section>
      </main>

      <FilterDrawer
        open={drawerOpen}
        filters={filters}
        counts={filterCounts}
        onChange={updateFilters}
        onClose={() => setDrawerOpen(false)}
      />

      <SiteFooter />
    </div>
  )
}
